export default "__VITE_ASSET__a924b556__"